import { render, staticRenderFns } from "./EdIcone.vue?vue&type=template&id=31965ac6&"
import script from "./EdIcone.vue?vue&type=script&lang=js&"
export * from "./EdIcone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports